export default [
    {
        path: "travel-orders",
        name: "operations-travel-orders",
        redirect: { name: "operations-travel-orders-list" },
        component: () => import("@/views/operations/views/travel-orders/TravelOrders.vue"),
        meta: {
            section: 31,
            breadcrumb: [
                {
                    text: "Travel Orders",
                    active: true,
                },
            ],

            tabs: [
                {
                    title: "Travels",
                    name: "operations-travel-orders-list",
                },
                // {
                //   title: "Departament",
                //   name: "rrhh-employees-departament",
                // },
            ],
        },
        children: [
            {
                path: "list",
                name: "operations-travel-orders-list",
                component: () =>
                    import("@/views/operations/views/travel-orders/components/TravelOrdersTable.vue"),
                meta: {
                    section: 31,
                    pageTitle: "Travel Orders",
                    breadcrumb: [
                        {
                            text: "Travels",
                        },
                    ],
                },
            },
        ]
    }
];